module.exports = __webpack_public_path__ + "static/media/Benjamin L.ac9fd571.jpg";